<template>
    <svg xmlns="http://www.w3.org/2000/svg" class="icon" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"></path></svg>
</template>
<script>
export default {
    
}
</script>
<style scoped>
    .icon{
         stroke: currentColor;
         height:1rem;
        margin-top:-0.3rem;
        margin-right:0.4rem;
    }
</style>